import '../Sass/App.scss';
import React, { useState } from 'react';
import { Card } from './Card2';
import { Modify } from './Modify';
import { useDrop } from 'react-dnd';
import Dialog from '@mui/material/Dialog';

let subHeader = "You can drag cards into this box to add to it."

export function Deck (props) {

    const [searching, setSearching] = useState(false)
    const [modalOpen, setModalOpen] = useState(false)
    const [cardInFocus, setCardInFocus] = useState({cardData: null, indexInSeries: null})
    const [modifyOpen, setModifyOpen] = useState(false)

    const [{ isOver }, dropRef] = useDrop({
        accept: ['dev-card','ml-card','viral-card'],
        drop: (item) => {
            const dragIndex = item.indexInSeries
            const dropIndex = props.indexInSeries
            item.sendHandler(dragIndex, 1)
            receiveCard(item.cardData, dropIndex)
        },
        collect: (monitor) => ({
            isOver: monitor.isOver()
        })
    })

    const cardHeight = (props.type == 'viral') ? props.cardWidth * 0.7 : props.cardWidth * 1.4

    function shuffleCodebase() {
        const shuffled = [...props.cards].sort(() => 0.5 - Math.random());
        props.setCards(rebuildDeckInfo(shuffled, props.deckIndex))
    }

    function receiveCard(card, dropIndex) {
        const currentCodebase = [...props.cards]
        var newCodebase = []
        if (searching) {
            newCodebase = [...currentCodebase.slice(0,dropIndex+1), card, ...currentCodebase.slice(dropIndex+1,currentCodebase.length)]
        } else {
            newCodebase = [...currentCodebase.slice(0,dropIndex), card, ...currentCodebase.slice(dropIndex,currentCodebase.length)]
        }
        props.setCards(rebuildDeckInfo(newCodebase, props.deckIndex))
    }

    function sendCards(cardIndex, number_of_cards) {
        const currentCodebase = [...props.cards]
        const remainingCodebase = [
            ...currentCodebase.slice(0,cardIndex),
            ...currentCodebase.slice(cardIndex + number_of_cards,currentCodebase.length)
        ]
        props.setCards(rebuildDeckInfo(remainingCodebase, props.deckIndex))
        setModalOpen(false)
    }

    function reorder() {
    }

    function rebuildDeckInfo(newDeck, deckIndex) {
        if (props.decks) {
            const decks = [...props.decks]
            const rebuiltDecks = [
                ...decks.slice(0,deckIndex),
                newDeck,
                ...decks.slice(deckIndex+1,decks.length),
            ]  
            return rebuiltDecks
        } else {
            return newDeck
        }
    }

    function rebuildDeckInfo(newDeck, deckIndex) {
        if (props.decks) {
            const decks = [...props.decks]
            const rebuiltDecks = [
                ...decks.slice(0,deckIndex),
                newDeck,
                ...decks.slice(deckIndex+1,decks.length),
            ]  
            return rebuiltDecks
        } else {
            return newDeck
        }
    }

    function getHeader() {
        switch (props.cardStyle) {
            case 'deck':
                return "Your Codebase is empty!"
            case 'discard':
                return "This discard pile is empty!";
            default:
                return "This deck is empty!";
        }
    }

    function expandCard(cardData, indexInSeries) {
        setCardInFocus({ cardData: cardData, indexInSeries: indexInSeries })
        setModalOpen(true)
    }

    function modifyCard() {
        setModalOpen(false)
        setModifyOpen(true)
    }

    function changeCardData(position, newData) {
        const currentHand = [...props.cards]
        props.setCards([
            ...currentHand.slice(0,position),
            newData,
            ...currentHand.slice(position+1, currentHand.length)
        ])
        setModifyOpen(false)
    }


    return (
        <div className='deck-holder' style={{maxWidth: props.cardWidth + 20}}>
            { !searching ?
                 props.cards.length > 0 ? 
                    <>
                    <Card currentHome={props.currentHome} clickHandler={expandCard} sendHandler={sendCards} reorderHandler={reorder} receiveHandler={receiveCard} cardData={props.cards[0]} codebase={props.codebase} cardWidth={props.cardWidth} cardStyle={props.cardStyle} indexInSeries={0} />
                    <div style={{textAlign: 'center'}}>
                        <h3 style={{fontSize: props.cardWidth / 13}}>{props.name}</h3>
                        <span className='green-code' style={{fontSize: props.cardWidth / 14}}><b>{props.cards.length}</b> cards</span>
                        <button className="cli-button" onClick={shuffleCodebase} style={{fontSize: props.cardWidth / 14}}>shuffle</button>
                        <button className="cli-button" onClick={() => setSearching(true)} style={{fontSize: props.cardWidth / 14}}>search</button>
                    </div>
                    </>
                : 
                    <div className='hand-empty' style={{height: cardHeight - ( props.type == 'viral' ? 20 : 40 ), width: props.cardWidth - ( props.type == 'viral' ? 20 : 40 ), padding: props.type == 'viral' ? 10 : 20, fontSize: props.cardWidth / ( props.type == 'viral' ? 14 : 12 ) }} ref={dropRef}>
                        <p><b>{ getHeader() }</b></p>{ props.type != 'viral' && <p className='green-code'>{subHeader}</p> }
                    </div> 
                
            : 
                <div style={{position: 'absolute', zIndex: 1110, top: '100px', right: '50px', width: '40%', border: '1px solid #00B000', padding: '20px', backgroundColor: 'black', boxShadow: '-5px 5px 5px #00B000'}}>
                    <h2><span style={{float: 'left', paddingTop: '1%'}}>Searching: {props.name}</span><span style={{float: 'right'}}><button onClick={() => setSearching(false)} className="cli-button">CLOSE</button></span></h2>
                    <div style={{width: '85%'}}>
                    { props.cards.map((card, index) =>
                        <Card currentHome={props.currentHome} clickHandler={expandCard} sendHandler={sendCards} reorderHandler={reorder} receiveHandler={receiveCard} cardData={card} codebase={props.codebase} cardWidth={props.cardWidth} cardStyle='hand' key={index} indexInSeries={index} />
                    )}
                    </div>
                </div>
            }
        <Dialog
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            PaperProps={{sx: {bgcolor: 'transparent'}}}
            >
                <Card cardData={cardInFocus.cardData} indexInSeries={cardInFocus.indexInSeries} cardWidth={500} showQuantity={false} options={true} sendHandler={sendCards} modifyHandler={modifyCard} notDraggable />
                <button className="close-button" style={{right: 0, top: 0, zIndex: 2500}} onClick={() => setModalOpen(false)}>X</button>
        </Dialog>
        <Dialog
            open={modifyOpen}
            maxWidth='xl'
            fullWidth={true}
            onClose={() => setModifyOpen(false)}
            PaperProps={{sx: {bgcolor: 'black', border: 1, borderColor: 'white', padding: 3, color: 'white'}}}
            >
                <Modify cardData={cardInFocus.cardData} indexInSeries={cardInFocus.indexInSeries} changeHandler={changeCardData} setModifyOpen={setModifyOpen} />
        </Dialog>
        </div>
    )

}